import { ACHIEVEMENT, AchievementInfo } from "@/interface/learning";

export const ACHIEVEMENT_INFO: Record<ACHIEVEMENT, AchievementInfo> = {
  [ACHIEVEMENT.DOWNLOAD_DATASET]: {
    name: "downloadDataset",
    label: "Download a dataset and successfully show some data samples.",
  },
  [ACHIEVEMENT.TRAIN_CV_MODEL]: {
    name: "trainCVModel",
    label: "Train a model on the MNIST dataset with over 0.9 accuracy.",
  },
  [ACHIEVEMENT.EVALUATE_CV_MODEL]: {
    name: "evaluateCVModel",
    label: "Evaluate the CV Model",
  },
  [ACHIEVEMENT.TRAIN_NLP_MODEL]: {
    name: "trainNLPModel",
    label: "Train a model on the IMDB Review dataset with over 0.7 accuracy.",
  },
  [ACHIEVEMENT.EVALUATE_NLP_MODEL]: {
    name: "evaluateNLPModel",
    label: "Evaluate the NLP Model",
  },
};
